import config from "../../config/config";

export async function fetchPublicApplicationLogs({
  fromDate,
  toDate,
} = {}) {
  const from = String(fromDate || "").trim();
  const to = String(toDate || "").trim();
  if (!from || !to) {
    throw new Error("From date and To date are required");
  }

  const params = new URLSearchParams({
    fromDate: from,
    toDate: to,
  });

  const res = await fetch(
    `${config.BASE_URL}/application-logs-public?${params.toString()}`,
    { credentials: "include" },
  );

  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(json?.message || "Failed to fetch application logs");
  }

  return {
    rows: Array.isArray(json?.data) ? json.data : [],
    meta: json?.meta || {
      total: 0,
      returned: 0,
      capped: false,
      fromDate: from,
      toDate: to,
    },
  };
}

export async function fetchPublicApplicationLogById(id) {
  const res = await fetch(`${config.BASE_URL}/application-logs-public/${encodeURIComponent(String(id))}`, {
    credentials: "include",
  });
  if (!res.ok) {
    throw new Error("Failed to fetch application log details");
  }
  const json = await res.json();
  return json?.data || null;
}
